import React from 'react';
import { connect } from 'react-redux';
import Sound from 'react-sound';
import styled, { css, keyframes } from 'styled-components';
import UIfx from 'uifx';
import {
  setBossRanks,
  resetPowerSearch,
  setPowerSearch,
  bossDefeated,
} from '../../actions/learn-fight';
import { useImagesContext } from '../../contexts/ImagesContext';
import {
  getTwilightZoneStage,
  getBossRanks,
  setPassTwilightZoneStage,
} from '../../services/twilight_zone';
import { getImageUrl } from '../../utils/image';
import { ImgClick } from '../utility';

import answerCorrectFile from './sounds/answer-correct.mp3';
import answerWrongFile from './sounds/answer-wrong.ogg';
import bossBrokenShieldFile from './sounds/boss-broken-shield.mp3';
import bossDoubleAttackFile from './sounds/boss-double-attack.mp3';
import userStartingFile from './sounds/boss-tuagom-pic-starting.ogg';
import figthBossBackground from './sounds/fight-boss-background.mp3';
import winNormalBoss from './sounds/win-normal-boss.mp3';
import winRewardLast from './sounds/win-reward-last.mp3';
import loseFile from './sounds/lose.ogg';
import playerAttackingFile from './sounds/player-attacking.mp3';
import bossAttackingFile from './sounds/boss-attacking.mp3';
import playBrokenShieldFile from './sounds/player-broken-shield.mp3';
import playerDoubleAtteckFile from './sounds/player-double-attack.mp3';
import questionStartFile from './sounds/question-start.mp3';
import winFile from './sounds/win.ogg';

import { ATTACK_MULTIPLIER } from '../../constant';
import {
  bossAttack,
  gotAttack,
  gotPierce,
  playerAttack,
} from '../../functions/fight_boss';
import { use } from 'react';
import { useShortcut } from '../../utils/useShortcut';

const questionStartSound = new UIfx(questionStartFile);
const loseSound = new UIfx(loseFile);
const winSound = new UIfx(winFile);
const answerCorrect = new UIfx(answerCorrectFile);
const answerWrong = new UIfx(answerWrongFile);
const playerDoubleAtteckSound = new UIfx(playerDoubleAtteckFile);
const bossBrokenShieldSound = new UIfx(bossBrokenShieldFile);
const playerAttackingSound = new UIfx(playerAttackingFile);
const bossAttackingSound = new UIfx(bossAttackingFile);
const playBrokenShieldSound = new UIfx(playBrokenShieldFile);
const bossDoubleAttackSound = new UIfx(bossDoubleAttackFile);

const POWER_MAP = {
  100: '01',
  90: '02',
  80: '03',
  70: '04',
  60: '05',
  50: '06',
  40: '07',
  30: '08',
  20: '09',
  10: '10',
  0: '11',
};

const delay = (ms) => new Promise((resolve) => setTimeout(resolve, ms));

function getPowerFileImage(maxPower, currentPower) {
  console.debug('getPowerFileImage', { maxPower, currentPower });
  if (maxPower === null || maxPower === undefined) {
    return '01';
  }
  const powerPercentage = (currentPower / maxPower) * 100;
  const powerFile = Math.floor(powerPercentage / 10) * 10;
  return POWER_MAP[powerFile];
}

const NUMBER_COLURS = {
  YELLOW: 'yellow',
  RED: 'red',
};

const NumberColor = ({ color, number }) => {
  console.debug('NumberColor', { color, number });
  const { images } = useImagesContext();
  if (number === null || number === undefined) {
    return null;
  }
  const numberString = number.toString();
  // console.debug('numberString:', numberString);
  const numberArray = [];
  for (let i = 0; i < numberString.length; i++) {
    // console.debug('filename:', `boss-number-${color}-${numberString[i]}.png`);
    numberArray.push(
      <NumberImg
        key={`number_${color}_${i}`}
        src={images[`boss-number-${color}-${numberString[i]}.png`]}
      />,
    );
  }
  // console.debug(numberArray);
  return numberArray;
};

const GamePowerBlock = ({ powerType, powerValue, images }) => {
  return (
    <GamePowerItemBlock>
      <GamePowerItemImg
        src={
          images[
            powerValue > 0
              ? `power-${powerType}${powerValue}.png`
              : 'power-none.png'
          ]
        }
        alt=""
      />
      <GamePowerItemText>{powerValue > 0 ? powerValue : '-'}</GamePowerItemText>
    </GamePowerItemBlock>
  );
};

const FIGHT_BOSS_STATE = {
  begin: 'begin',
  fight: 'fight',
  questionStart: 'questionStart',
  win: 'win',
  winRewardNormal: 'winRewardNormal',
  winRewardLast: 'winRewardLast',
  lose: 'lose',
  correct: 'correct',
  notCorrect: 'notCorrect',
  answerCheck: 'answerCheck',
  startDice: 'startDice',
  Dicing: 'Dicing',
  afterDice: 'afterDice',
  bossBrokenShield: 'bossBrokenShield',
  playerDoubleAttack: 'playerDoubleAttack',
  playerAttack: 'playerAttack',
  playerBrokenShield: 'playerBrokenShield',
  bossDoubleAttack: 'bossDoubleAttack',
  bossAttack: 'bossAttack',
};

const TwilightZoneStageBoss = ({
  stage,
  twilightZone,
  student,
  handleBack,
  handleCompleted,
  config,
  bossRanks,
  setBossRanks,
  bossDefeated,
}) => {
  const { images } = useImagesContext();

  // console.debug('TwilightZoneStageBoss.twilightZone', twilightZone);
  // console.debug('TwilightZoneStageBoss.stage', stage);
  // const [studentPower, setStudentPower] = React.useState(30);
  const [studentData, setStudentData] = React.useState({});
  const [currentBossHp, setCurrentBossHp] = React.useState(
    // BOSS_RANKS[stage.bossRank].health
    null,
  );
  const [boss, setBoss] = React.useState(null);
  const [question, setQuestion] = React.useState(null);
  const [pressedButton, setPressButton] = React.useState(null);
  const [fightBossState, setFightBossState] = React.useState([
    FIGHT_BOSS_STATE.begin,
    FIGHT_BOSS_STATE.fight,
  ]);
  const [random, setRandom] = React.useState(null);
  const [multiplier, setMultiplier] = React.useState(null);
  const [pierce, setPierce] = React.useState(false);
  const [currentPlayerHp, setCurrentPlayerHp] = React.useState(null);
  const [rememberNumber, setRememberNumber] = React.useState(null);
  const [questionData, setQuestionData] = React.useState(
    window.localStorage.getItem('question') || {
      allItems: [],
      items: [],
      stateId: null,
      studentId: null,
    },
  );

  useShortcut('1', () => {
    if (hasState(FIGHT_BOSS_STATE.questionStart)) {
      chooseAnswer('A');
    }
  });
  useShortcut('2', () => {
    if (hasState(FIGHT_BOSS_STATE.questionStart)) {
      chooseAnswer('B');
    } else if (hasState(FIGHT_BOSS_STATE.startDice)) {
      handleDoCorrect();
    }
  });

  useShortcut('3', () => {
    if (hasState(FIGHT_BOSS_STATE.questionStart)) {
      chooseAnswer('C');
    }
  });

  // const bossMaxPower = 40;

  React.useEffect(() => {
    const _func = async () => {
      if (bossRanks === null) {
        const retBossRanks = await getBossRanks();
        setBossRanks(retBossRanks.data);
        const bossData = retBossRanks.data.find(
          (boss) => boss.code === stage.bossRank,
        );
        setBoss(bossData);
        setCurrentBossHp(bossData.health);
      } else {
        const bossData = bossRanks.find((boss) => boss.code === stage.bossRank);
        setBoss(bossData);
        setCurrentBossHp(bossData.health);
      }
      let response = await getTwilightZoneStage(student.id, stage.id);
      console.debug('getTwilightZoneStage:', response.data);
      setStudentData(response.data);
      setCurrentPlayerHp(response.data.studentPower.hp);
      if (
        questionData.studentId !== student.id ||
        questionData.stateId !== stage.id
      ) {
        console.debug('setQuestionData');
        const data = {
          studentId: student.id,
          stateId: stage.id,
          allItems: response.data.stage.questions,
          items: response.data.stage.questions,
        };
        setQuestionData(data);
        _newQuestion(data);
      } else {
        newQuestion();
      }
    };
    _func();
  }, []);

  function _newQuestion(questionData) {
    console.debug('_newQuestion', questionData);
    if (questionData.items.length === 0) {
      handleBack();
    }
    const question =
      questionData.items[Math.floor(Math.random() * questionData.items.length)];
    console.debug('question', question);
    if (questionData.items.length === 1) {
      setQuestionData({
        ...questionData,
        items: questionData.allItems,
      });
    } else {
      setQuestionData({
        ...questionData,
        items: questionData.items.filter((q) => q.id !== question.id),
      });
    }
    setQuestion(question);
  }

  function newQuestion() {
    _newQuestion(questionData);
  }

  async function doCorrect() {
    console.debug('correct');
    setState(FIGHT_BOSS_STATE.correct);
    if (!config.isMutedSound) answerCorrect.play();
    setPressButton((_) => null);
    await delay(2500);
    setState(FIGHT_BOSS_STATE.startDice);
  }

  async function doWrong() {
    console.debug('wrong');
    setState(FIGHT_BOSS_STATE.notCorrect);
    if (!config.isMutedSound) answerWrong.play();
    const attackPierce = gotPierce(boss.pierce);
    const [_, attackMultiple] = gotAttack(boss.luck);
    console.debug(
      `bossAttack: boss.attack=${boss.attack} pierce=${attackPierce} multiple=${attackMultiple} player.def=${studentData.studentPower.def} player.hp=${currentPlayerHp}`,
    );
    const retPlayerHp = bossAttack(
      boss.attack,
      attackPierce,
      attackMultiple,
      studentData.studentPower.def,
      currentPlayerHp,
    );
    console.debug(`bossAttack: retPlayerHp=${retPlayerHp}`);
    setPressButton((_) => null);
    // await delay(2000);
    // if (attackPierce) {
    addState(FIGHT_BOSS_STATE.playerBrokenShield);
    if (!config.isMutedSound) playBrokenShieldSound.play();
    // await delay(1000);
    // }

    // if (attackMultiple === ATTACK_MULTIPLIER.double) {
    addState(FIGHT_BOSS_STATE.bossDoubleAttack);
    if (!config.isMutedSound) bossDoubleAttackSound.play();
    // await delay(1000);
    // }
    // If Boss got attack
    // await delay(1000);
    addState(FIGHT_BOSS_STATE.bossAttack);
    if (!config.isMutedSound) bossAttackingSound.play();
    await delay(3000);
    const targetBarPower = retPlayerHp;
    let currentBarPower = currentPlayerHp;
    let powerBarStep = Math.floor(studentData.studentPower.hp / 10);
    if (powerBarStep < 1) {
      powerBarStep = 1;
    }
    // console.debug('currentBarPower:', currentBarPower);
    // console.debug('targetBarPower:', targetBarPower);
    // console.debug('powerBarStep:', powerBarStep);
    while (true) {
      currentBarPower -= powerBarStep;
      if (currentBarPower > targetBarPower) {
        // setTimeout(() => {
        setCurrentPlayerHp(currentBarPower);
        // }, 500);
        await delay(500);
      } else {
        // setTimeout(() => {
        setCurrentPlayerHp(targetBarPower);
        // }, 500);
        await delay(500);
        break;
      }
    }
    if (retPlayerHp > 0) {
      await delay(1000);
      setState(FIGHT_BOSS_STATE.questionStart);
      if (!config.isMutedSound) {
        console.debug('questionStartSound.play()');
        if (!config.isMutedSound) questionStartSound.play();
      }
      newQuestion();
    } else {
      setState(FIGHT_BOSS_STATE.lose);
      if (!config.isMutedSound) loseSound.play();
      await delay(4000);
      saveQuestionData();
      handleBack();
      // await delay(1000);
    }
  }

  function saveQuestionData() {
    window.localStorage.setItem('question', questionData);
  }

  async function chooseAnswer(answer) {
    setPressButton(answer);
    await delay(1000);
    if (question.answer === answer) {
      doCorrect();
    } else {
      doWrong();
    }
  }

  function hasState(state) {
    // console.debug('hasState', fightBossState, state);
    return fightBossState.find((v) => v === state) !== undefined;
  }

  function addState(stage) {
    setFightBossState((v) => [...v, stage]);
  }

  // function removeState(stage) {
  //   setFightBossState(fightBossState.filter((v) => v !== stage));
  // }

  function setState(stage) {
    setFightBossState((v) => [stage]);
  }

  // console.debug('question', question);
  function handleWin() {
    saveQuestionData();
    setPassTwilightZoneStage(student.id, stage.id).then(async (resp) => {
      console.debug('setPassTwilightZoneStage:', resp.data);
      if (resp.data.hiddenPower) {
        // normal Boss
        addState(FIGHT_BOSS_STATE.winRewardNormal);
        await delay(5000);
        bossDefeated(stage.id);
        handleCompleted();
      } else if (resp.data.rememberNumber) {
        // last Boss
        addState(FIGHT_BOSS_STATE.winRewardLast);
        setRememberNumber(resp.data.rememberNumber);
        await delay(4000);
        bossDefeated(stage.id);
        handleCompleted();
      }
    });
  }

  async function handleDoCorrect() {
    setState(FIGHT_BOSS_STATE.Dicing);
    await delay(1000);
    let pierceValue = gotPierce(studentData.studentPower.piercing);
    setPierce(pierceValue);
    let [random, multiplier] = gotAttack(studentData.studentPower.luck);
    addState(FIGHT_BOSS_STATE.afterDice);
    await delay(500);
    setRandom(random);
    // await delay(1500);
    setMultiplier(multiplier);
    console.debug(
      `playerAttack: player.attack=${studentData.studentPower.atk} pierce=${pierceValue} multiple=${multiplier} boss.def=${boss.defence} boss.hp=${currentBossHp}`,
    );
    const retBossHp = playerAttack(
      studentData.studentPower.atk,
      pierceValue,
      multiplier,
      boss.defence,
      currentBossHp,
    );
    console.debug(`playerAttack: retBossHp=${retBossHp}`);

    if (multiplier === ATTACK_MULTIPLIER.double) {
      addState(FIGHT_BOSS_STATE.playerDoubleAttack);
      if (!config.isMutedSound) playerDoubleAtteckSound.play();
      await delay(1500);
    }

    console.debug('playerAttack');
    addState(FIGHT_BOSS_STATE.playerAttack);
    if (!config.isMutedSound) playerAttackingSound.play();
    if (pierceValue) {
      setTimeout(() => {
        addState(FIGHT_BOSS_STATE.bossBrokenShield);
        if (!config.isMutedSound) bossBrokenShieldSound.play();
      }, 1500);
    }
    await delay(2000);
    const targetBarPower = retBossHp;
    let currentBarPower = currentBossHp;
    let powerBarStep = Math.floor(boss.health / 10);
    if (powerBarStep < 1) {
      powerBarStep = 1;
    }
    // console.debug('currentBarPower:', currentBarPower);
    // console.debug('targetBarPower:', targetBarPower);
    // console.debug('powerBarStep:', powerBarStep);
    while (true) {
      currentBarPower -= powerBarStep;
      if (currentBarPower > targetBarPower) {
        setCurrentBossHp(currentBarPower);
        await delay(500);
      } else {
        setCurrentBossHp(targetBarPower);
        await delay(500);
        break;
      }
    }
    setPierce((_) => false);
    setPressButton((_) => null);
    if (retBossHp > 0) {
      await delay(1000);
      setRandom((_) => null);
      setState(FIGHT_BOSS_STATE.questionStart);
      if (!config.isMutedSound) {
        console.debug('questionStartSound.play()');
        if (!config.isMutedSound) questionStartSound.play();
      }
      newQuestion();
    } else {
      setState(FIGHT_BOSS_STATE.win);
      if (!config.isMutedSound) winSound.play();
      await delay(2000);
      handleWin();
    }
  }

  function getRewardImage() {
    if (hasState(FIGHT_BOSS_STATE.winRewardNormal)) {
      return images['win-normal-boss.png'];
    }
    if (hasState(FIGHT_BOSS_STATE.winRewardLast)) {
      return images[
        `win-reward-A${String(rememberNumber).padStart(2, '0')}.png`
      ];
    }
    return null;
  }

  function getHiddenPowerBlockImage() {
    switch (student.powerType) {
      case 'atk':
        return images['boss-hidden-power-block-atk.png'];
      case 'def':
        return images['boss-hidden-power-block-def.png'];
      case 'hp':
        return images['boss-hidden-power-block-hp.png'];
      default:
        return images['boss-hidden-power-block.png'];
    }
  }

  console.debug('TwilightZoneStageBoss.twilightZone', twilightZone);

  return (
    <Container>
      <Background src={getImageUrl(twilightZone.bossBackground)} />
      {!hasState(FIGHT_BOSS_STATE.begin) && (
        <TuagomPic
          $fadeOut={hasState(FIGHT_BOSS_STATE.lose)}
          src={images['boss-tuagom-pic.png']}
        />
      )}
      <Sound
        url={figthBossBackground}
        playStatus="PLAYING"
        volume={config.isMutedSound ? 0 : 30}
        loop={true}
      ></Sound>
      <BossPic
        $fadeOut={hasState(FIGHT_BOSS_STATE.win)}
        src={getImageUrl(stage.bossImage)}
      />
      <QuestionStart
        src={
          hasState(FIGHT_BOSS_STATE.questionStart)
            ? images['boos-question-start.png']
            : null
        }
      />
      <FullScreenReward src={getRewardImage()} alt="" />
      {
        // win stage show reward
        hasState(FIGHT_BOSS_STATE.winRewardNormal) && (
          <>
            <FilterDark />
            <Sound
              url={winNormalBoss}
              playStatus="PLAYING"
              volume={config.isMutedSound ? 0 : 100}
            ></Sound>
          </>
        )
      }
      {
        // win stage show reward
        hasState(FIGHT_BOSS_STATE.winRewardLast) && (
          <>
            <FilterDark />
            <Sound
              url={winRewardLast}
              playStatus="PLAYING"
              volume={config.isMutedSound ? 0 : 100}
            ></Sound>
          </>
        )
      }
      <StudentBlock>
        <StudentImageBlock $width={128} $height={127}>
          <StudentImage src={getImageUrl(student.avatar)} />
          <StudentBorder src={images['boss-student-bg.png']} />
        </StudentImageBlock>
        <BlockInfo $width={416} $height={138}>
          <StudentPowerBar
            src={
              images[
                `boss-bar-yellow-${getPowerFileImage(
                  studentData.studentPower ? studentData.studentPower.hp : null,
                  currentPlayerHp,
                )}.png`
              ]
            }
          />
          <NumberColor color={NUMBER_COLURS.YELLOW} number={currentPlayerHp} />
        </BlockInfo>
        <BlockInfo
          $bg={images['boss-armor-yellow.png']}
          $width={126}
          $height={147}
        >
          <NumberColor
            color={NUMBER_COLURS.YELLOW}
            number={
              studentData.studentPower ? studentData.studentPower.def : null
            }
          />
        </BlockInfo>
        <BlockInfo
          $bg={images['boss-attack-student.png']}
          $width={152}
          $height={152}
        >
          <NumberColor
            color={NUMBER_COLURS.YELLOW}
            number={
              studentData.studentPower ? studentData.studentPower.atk : null
            }
          />
        </BlockInfo>
      </StudentBlock>
      <BossBlock>
        <BlockInfo
          $bg={images['boss-attack-boss.png']}
          $width={152}
          $height={152}
        >
          <NumberColor
            color={NUMBER_COLURS.RED}
            number={boss ? boss.attack : null}
          />
        </BlockInfo>
        <BlockInfo
          $bg={images['boss-armor-red.png']}
          $width={126}
          $height={147}
        >
          <NumberColor
            color={NUMBER_COLURS.RED}
            number={boss ? boss.defence : null}
          />
        </BlockInfo>
        <BlockInfo $width={416} $height={138}>
          <BossPowerBar
            src={
              images[
                `boss-bar-red-${getPowerFileImage(
                  boss ? boss.health : null,
                  currentBossHp,
                )}.png`
              ]
            }
          />
          <NumberColor color={NUMBER_COLURS.RED} number={currentBossHp} />
        </BlockInfo>
      </BossBlock>
      <HiddenPowerBlock
        $bg={getHiddenPowerBlockImage()}
        $width={118}
        $height={126}
      >
        <HiddenPowerNumberBlock>
          {studentData.hiddenPower ? `${studentData.hiddenPower}%` : null}
        </HiddenPowerNumberBlock>
      </HiddenPowerBlock>
      <StudentItemsBlock>
        {studentData &&
        studentData.studentAmulets &&
        studentData.studentAmulets[0] ? (
          <StudentItem
            $bg={images['boss-item-border.png']}
            $width={144}
            $height={144}
          >
            <StudentItemImage
              src={
                images[
                  `amulet_${String(
                    studentData.studentAmulets[0].number,
                  ).padStart(2, '0')}.png`
                ]
              }
              alt=""
            />
          </StudentItem>
        ) : (
          <StudentItem
            $bg={images['boss-item-empty.png']}
            $width={144}
            $height={144}
          />
        )}
        {studentData &&
        studentData.studentAmulets &&
        studentData.studentAmulets[1] ? (
          <StudentItem
            $bg={images['boss-item-border.png']}
            $width={144}
            $height={144}
          >
            <StudentItemImage
              src={
                images[
                  `amulet_${String(
                    studentData.studentAmulets[1].number,
                  ).padStart(2, '0')}.png`
                ]
              }
              alt=""
            />
          </StudentItem>
        ) : (
          <StudentItem
            $bg={images['boss-item-empty.png']}
            $width={144}
            $height={144}
          />
        )}
      </StudentItemsBlock>
      <BossImage />
      {boss && (
        <BossRank src={images[`rank-${boss.code.toLowerCase()}.png`]} alt="" />
      )}
      {hasState(FIGHT_BOSS_STATE.begin) && (
        <>
          <Sound
            url={userStartingFile}
            playStatus="PLAYING"
            onFinishedPlaying={() => {
              console.debug('questionStartSound.play()', config.isMutedSound);
              setTimeout(() => {
                setState(FIGHT_BOSS_STATE.questionStart);
                if (!config.isMutedSound) {
                  console.debug('questionStartSound.play()');
                  if (!config.isMutedSound) questionStartSound.play();
                }
              }, 1000);
            }}
            volume={config.isMutedSound ? 0 : undefined}
          ></Sound>
        </>
      )}
      <TuagomPicStarting
        src={
          hasState(FIGHT_BOSS_STATE.begin)
            ? images['boss-tuagom-pic-starting.png']
            : null
        }
      />
      <FullScreenImg
        src={hasState(FIGHT_BOSS_STATE.fight) ? images['fight.png'] : null}
        alt=""
      />
      {hasState(FIGHT_BOSS_STATE.questionStart) && (
        <FullScreenImgWithFadeInOut
          src={question !== null ? getImageUrl(question.image) : null}
          alt=""
        />
      )}
      {hasState(FIGHT_BOSS_STATE.questionStart) && (
        <>
          {pressedButton === null && (
            <FullScreenImgWithFadeIn
              src={images['answer-buttions.png']}
              alt=""
            />
          )}
          <ButtonA
            onClick={() => {
              chooseAnswer('A');
            }}
          ></ButtonA>
          <ButtonB
            onClick={() => {
              chooseAnswer('B');
            }}
          ></ButtonB>
          <ButtonC
            onClick={() => {
              chooseAnswer('C');
            }}
          ></ButtonC>
        </>
      )}
      {pressedButton === 'A' && (
        <FullScreenImgWithFadeOut src={images['answer-a-pressed.png']} alt="" />
      )}
      {pressedButton === 'B' && (
        <FullScreenImgWithFadeOut src={images['answer-b-pressed.png']} alt="" />
      )}
      {pressedButton === 'C' && (
        <FullScreenImgWithFadeOut src={images['answer-c-pressed.png']} alt="" />
      )}
      {hasState(FIGHT_BOSS_STATE.win) && (
        <Sound
          url={winFile}
          playStatus="PLAYING"
          loop={false}
          volume={config.isMutedSound ? 0 : 100}
        ></Sound>
      )}
      <FullScreenImg
        src={hasState(FIGHT_BOSS_STATE.win) ? images['win.png'] : null}
        alt=""
      />
      <FullScreenImg
        src={hasState(FIGHT_BOSS_STATE.lose) ? images['lose.png'] : null}
        alt=""
      />
      <FullScreenImg
        src={
          hasState(FIGHT_BOSS_STATE.correct)
            ? images['answer-correct.png']
            : null
        }
        alt=""
      />
      <FullScreenImg
        src={
          hasState(FIGHT_BOSS_STATE.startDice)
            ? images['roll-dice-before.png']
            : null
        }
        alt=""
      />
      {hasState(FIGHT_BOSS_STATE.startDice) && (
        <DiceButtion
          onClick={() => {
            handleDoCorrect();
          }}
        />
      )}
      <BossShieldBrokenImg
        src={
          hasState(FIGHT_BOSS_STATE.bossBrokenShield) && pierce
            ? images['broken-shield.png']
            : null
        }
        alt=""
      />
      {/* <BossShieldBrokenImg src={images['broken-shield.png']} alt="" /> */}
      <FullScreenImg
        src={
          hasState(FIGHT_BOSS_STATE.playerDoubleAttack) &&
          multiplier === ATTACK_MULTIPLIER.double
            ? images['attack-doubled.png']
            : null
        }
        alt=""
      />
      {hasState(FIGHT_BOSS_STATE.Dicing) && (
        <Dice
          $visible={hasState(FIGHT_BOSS_STATE.Dicing)}
          src={images['roll-dice.png']}
          alt=""
        />
      )}
      <AfterDice
        src={
          hasState(FIGHT_BOSS_STATE.afterDice) ? images['after-dice.png'] : null
        }
      />
      {/* <AfterDice src={images['after-dice.png']} /> */}
      {random !== null && (
        <Dice src={images[`roll-dice-${random}.png`]} alt="" />
      )}
      <FullScreenImg
        src={
          hasState(FIGHT_BOSS_STATE.playerAttack)
            ? images['player-attacking.png']
            : null
        }
        alt=""
      />
      <PlayerShieldBrokenImg
        src={
          hasState(FIGHT_BOSS_STATE.playerBrokenShield)
            ? images['player-broken-shield.png']
            : null
        }
        alt=""
      />
      <FullScreenImg
        src={
          hasState(FIGHT_BOSS_STATE.bossDoubleAttack)
            ? images['boss-double-attack.png']
            : null
        }
        alt=""
      />
      <FullScreenImg
        src={
          hasState(FIGHT_BOSS_STATE.notCorrect)
            ? images['answer-wrong.png']
            : null
        }
        alt=""
      />
      <Back
        onClick={async () => {
          setState(FIGHT_BOSS_STATE.lose);
          if (!config.isMutedSound) loseSound.play();
          await delay(4000);
          saveQuestionData();
          handleBack();
        }}
        src={images['boss-back.png']}
        alt=""
      />
    </Container>
  );
};

const AfterDice = styled.img`
  position: absolute;
  top: -20px;
  left: 800px;
`;

const FilterDark = styled.div`
  position: absolute;
  top: 0;
  left: 0;
  width: 1920px;
  height: 1080px;
  background-color: rgba(0, 0, 0, 0.5);
  z-index: 10;
`;

const FullScreenReward = styled.img`
  position: absolute;
  top: 0;
  left: 0;
  z-index: 11;
`;

const Dice = styled.img`
  position: absolute;
  top: 5px;
  left: 850px;
`;

const DiceButtion = styled.div`
  position: absolute;
  top: 5px;
  left: 850px;
  width: 207px;
  height: 211px;
  // border: 2px solid black;
`;

const fadeIn = keyframes`
  from {
    opacity: 0;
  }
  to {
    opacity: 1;
  }
`;

const fadeOut = keyframes`
  from {
    opacity: 1;
  }
  to {
    opacity: 0;
  }
`;

const FullScreenImgWithFadeInOut = styled.img`
  position: absolute;
  top: 0;
  left: 0;
  animation: ${fadeIn} 3s ease-in-out;
`;

const FullScreenImgWithFadeIn = styled.img`
  position: absolute;
  top: 0;
  left: 0;
  animation: ${fadeIn} 3s ease-in;
`;

const FullScreenImgWithFadeOut = styled.img`
  position: absolute;
  top: 0;
  left: 0;
  animation: ${fadeOut} 3s ease-out;
`;

const ButtonA = styled.div`
  position: absolute;
  left: 855px;
  top: 830px;
  // border: 2px solid black;
  height: 117px;
  width: 157px;
`;

const ButtonB = styled.div`
  position: absolute;
  left: 1037px;
  top: 850px;
  // border: 2px solid black;
  height: 117px;
  width: 157px;
`;

const ButtonC = styled.div`
  position: absolute;
  left: 1235px;
  top: 880px;
  // border: 2px solid black;
  height: 117px;
  width: 157px;
`;

const FullScreenImg = styled.img`
  position: absolute;
  top: 0;
  left: 0;
`;

const BossShieldBrokenImg = styled.img`
  position: absolute;
  top: -20px;
  right: 395px;
  z-index: 2;
`;

const PlayerShieldBrokenImg = styled.img`
  position: absolute;
  top: -20px;
  left: 430px;
  z-index: 2;
`;

const Container = styled.div`
  position: relative;
  width: 1920px;
  height: 1080px;
`;

const Background = styled.img`
  top: 0px;
  left: 0px;
  width: 1920px;
  height: 1080px;
  position: absolute;
  object-fit: contain;
`;

const StudentBlock = styled.div`
  position: absolute;
  top: 0px;
  left: 0px;
  display: flex;
  justify-content: center;
  align-items: center;
  // border: 2px solid black;
`;

const StudentImageBlock = styled.div`
  position: relative;
  width: ${(props) => props.$width}px;
  height: ${(props) => props.$height}px;
  // border: 2px solid black;
`;

const StudentImage = styled.img`
  position: absolute;
  top: 0;
  left: 0;
  border-radius: 50%;
  max-height: 100%;
  // border: 2px solid black;
`;

const StudentBorder = styled.img`
  position: absolute;
  top: 0;
  left: 0;
  max-height: 100%;
  // border: 2px solid black;
`;

const StudentPowerBar = styled.img`
  position: absolute;
`;

const BlockInfo = styled.div`
  background-image: url(${(props) => props.$bg});
  width: ${(props) => props.$width}px;
  height: ${(props) => props.$height}px;
  justify-content: center;
  align-items: center;
  display: flex;
  // border: 2px solid black;
`;

const BossPowerBar = styled.img`
  position: absolute;
`;

const BossBlock = styled.div`
  position: absolute;
  top: 0px;
  right: 120px;
  display: flex;
  justify-content: center;
  align-items: center;
  // border: 2px solid black;
`;

const NumberImg = styled.img`
  z-index: 1;
`;

const BossImage = styled.img``;

const BossRank = styled.img`
  position: absolute;
  top: 590px;
  right: 70px;
`;

const StudentItemsBlock = styled.div`
  position: absolute;
  left: 0px;
  top: 200px;
  display: flex;
  flex-direction: column;
`;

const StudentItem = styled.div`
  // position: absolute;
  background-image: url(${(props) => props.$bg});
  width: ${(props) => props.$width}px;
  height: ${(props) => props.$height}px;
`;

const StudentItemImage = styled.img`
  // position: absolute;
  // top: 50%;
  // left: 50%;
  // transform: translate(-50%, -50%);
  display: block;
  margin: 0 auto;
`;

const HiddenPowerBlock = styled.div`
  background-image: url(${(props) => props.$bg});
  width: ${(props) => props.$width}px;
  height: ${(props) => props.$height}px;
  position: absolute;
  left: 16px;
  bottom: 8px;
`;

const HiddenPowerNumberBlock = styled.div`
  margin-top: 45px;
  text-align: center;
  font-family: 'PSLxText';
  color: white;
  font-weight: bold;
  font-size: 52px;
  text-stroke: 4px black;
  -webkit-text-stroke: 0.05em black;
  paint-order: stroke fill;
`;

const Back = styled(ImgClick)`
  position: absolute;
  bottom: 24px;
  left: 180px;
`;

const GamePowerItemBlock = styled.div`
  text-jusitfy: center;
`;

const GamePowerItemImg = styled.img`
  display: block;
  margin: 0 auto;
`;

const GamePowerItemText = styled.div`
  // border: 1px solid black;
  font-family: PSLxText;
  font-weight: bold;
  font-size: 24px;
  color: white;
  margin-left: 75px;
`;

const TuagomPic = styled.img`
  ${(props) => {
    if (props.$fadeOut) {
      return css`
        position: absolute;
        opacity: 0;
        top: 0;
        left: 0;
        animation: ${fadeOut} 3s ease-in;
      `;
    }
    return css`
      position: absolute;
      opacity: 1;
      top: 0;
      left: 0;
    `;
  }}}
`;

const TuagomPicStarting = styled.img`
  position: absolute;
  top: 0;
  left: 0;
  z-index: 10;
`;

const BossPic = styled.img`
  ${(props) => {
    if (props.$fadeOut) {
      return css`
        position: absolute;
        opacity: 0;
        top: 0;
        left: 0;
        animation: ${fadeOut} 3s ease-in;
      `;
    }
    return css`
      position: absolute;
      opacity: 1;
      top: 0;
      left: 0;
    `;
  }}}  
`;

const QuestionStart = styled.img`
  position: absolute;
  top: 0;
  left: 0;
`;

const mapStateToProps = ({ student, learnFight, config }) => ({
  student,
  questions: learnFight.questions,
  bossRanks: learnFight.bossRanks,
  config,
});

const mapDispatchToProps = {
  setPowerSearch,
  resetPowerSearch,
  setBossRanks,
  bossDefeated,
};

export default connect(
  mapStateToProps,
  mapDispatchToProps,
)(TwilightZoneStageBoss);
